import { createSlice } from '@reduxjs/toolkit'

// 为 slice state 定义一个类型
interface FlowChartState {
  showPlugin: boolean
  openDrawer: boolean
}

// 使用该类型定义初始 state
const initialState: FlowChartState = {
  showPlugin: false,
  openDrawer: false,
}

const flowChartSlice = createSlice({
  name: 'flowChart',
  initialState,
  reducers: {
    onShow: state => {
      state.showPlugin = true
    },
    onOpen: state => {
      state.openDrawer = true
    },
    onHide: state => {
      state.showPlugin = false
    },
    onOk: state => {
      state.showPlugin = false
    },
    onClose: state => {
      state.openDrawer = false
    },
  },
})

export const { onShow, onOpen, onHide, onOk, onClose } = flowChartSlice.actions

export default flowChartSlice.reducer
